import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=d199e0ea&scoped=true"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"
import style0 from "./forgot_password.vue?vue&type=style&index=0&id=d199e0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d199e0ea",
  null
  
)

export default component.exports